import { ContentWrapperProps } from './types'
import { Tooltip } from '@frontend/design_system'
import { Typography } from '../Typography'
import { joinClasses } from 'utils/joinClasses'
import styles from './styles.module.scss'
import { InfoIcon } from 'ui/icons'

export const ContentWrapper = ({
  title,
  additionalContent,
  contentPosition = 'right',
  children,
  className = '',
  dataTestId = 'wrapper',
  tooltipContent,
}: ContentWrapperProps) => (
  <div
    className={joinClasses(styles.wrapper, className)}
    data-testid={dataTestId}
  >
    {title && (
      <div
        className={joinClasses(
          styles.header,
          styles[`content-${contentPosition}`]
        )}
      >
        <div className={styles['title-wrapper']}>
          <Typography
            markColor="red600Master"
            Tag="h5"
            name="H5"
            html={title}
          />
          {tooltipContent && (
            <Tooltip
              popupContent={tooltipContent}
              placement="bottom"
              alignSelf="center"
            >
              <InfoIcon color="blue700" size="medium" />
            </Tooltip>
          )}
        </div>
        {typeof additionalContent === 'string' ? (
          <Typography color="grey400" name="Subtitle4">
            {additionalContent}
          </Typography>
        ) : (
          additionalContent
        )}
      </div>
    )}
    <div className={styles.content}>{children}</div>
  </div>
)
